import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
//import { provideRouter, RouteReuseStrategy, withComponentInputBinding } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors } from '@angular/common/http';
//import { HashLocationStrategy, LocationStrategy } from '@angular/common';

//import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideAnimations } from '@angular/platform-browser/animations';
import { LoaderInterceptor } from '../app/interceptors/loader.interceptor';
import { authHeaderInterceptor } from './interceptors/auth-header.interceptor';
import { provideDatadogErrorHandler } from '@datadog/browser-rum-angular';
import { NAVIGATION_PROVIDERS } from '../app/layouts/navigation/navigation-providers';
import { environment } from '../environments/environment'
import {
  MsalService,
  MsalGuard,
  MsalBroadcastService,
  MsalInterceptor,
  MSAL_INSTANCE,
  MSAL_GUARD_CONFIG,
  MSAL_INTERCEPTOR_CONFIG,
  MsalGuardConfiguration,
  MsalInterceptorConfiguration
} from '@azure/msal-angular';

import { PublicClientApplication, InteractionType } from '@azure/msal-browser';

import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';



// import { APP_ROUTES } from '../app/app-routing.module'
// import {CustomRouteReuseStrategy } from '../app/custom-route-reuse.strategy'


export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['User.Read']);
  // add your API mappings too
  return {
    interactionType: InteractionType.Popup,
    protectedResourceMap
  };
}

export function MSALInstanceFactory() {
  return new PublicClientApplication({
    auth: {
      clientId: environment.AZ_CLIENT_ID,
      authority: `https://login.microsoftonline.com/${environment.AZ_TENANT_ID}`,
      redirectUri: environment.RMS_URL,
    }
  });
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Popup,
    authRequest: {
      scopes: ['User.Read'] // add your scopes forupdate
    }
  };
}


export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([LoaderInterceptor, authHeaderInterceptor])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideClientHydration(withEventReplay()),
    provideAnimationsAsync(),
    NAVIGATION_PROVIDERS,
    provideAnimations(),
    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
    { provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory },
    { provide: MSAL_GUARD_CONFIG, useFactory: MSALGuardConfigFactory },
    { provide: MSAL_INTERCEPTOR_CONFIG, useFactory: MSALInterceptorConfigFactory },

    MsalService,
    MsalGuard,
    MsalBroadcastService,
        importProvidersFrom(OverlayModule, PortalModule),
        provideDatadogErrorHandler(),

    //provideRouter(APP_ROUTES, withComponentInputBinding()),
    //{ provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
    //{ provide: LocationStrategy, useClass: HashLocationStrategy }
  ]
};
